import $ from 'jquery'
import { alert_error, post_json, get_json, eval_html_template,
         get_myinfo, has_user_loggedin, alert_message_html,
         populate_order_with_lines } from '../../../common'
import * as qs from 'querystring'

$(init)

async function init () {
  let $page = $('#view-order-page')
  if ($page.length == 0) {
    return
  }
  try {
    window.__fakesale = () => {
      onPurchaseSuccess()
    }
    let myinfo = await get_myinfo()
    let loggedin = has_user_loggedin(myinfo)
    if (!loggedin) {
      $page.find('.loading-indicator').addClass('d-none')
      return
    }
    let query = qs.parse(location.search.substr(1))
    let order_id = query.id
    if (!order_id) {
      throw new Error('id is not defined!')
    }
    if (query.stripe_return) {
      let locurl = new URL(window.location)
      locurl.searchParams.delete('stripe_return')
      history.replaceState({}, '', locurl)
      if (query.stripe_return == 'success') {
        try {
          await post_json(`/api/stripe/update-order-payment-status/${order_id}`)
          onPurchaseSuccess()
        } catch (err) {
          alert_error(err)
        }
      }
    }
    let order
    try {
      order = (await get_json(`/api/order/by-id/${order_id}`)).data
    } catch (err) {
      if (err.status_code != 404) {
        throw err
      }
    }
    $page.find('.loading-indicator').addClass('d-none')
    if (!order) {
      $page.find('.order-not-found').removeClass('d-none')
      return
    }
    let $order = $page.find('.order')
    update_order(order)
    $order.removeClass('d-none')
    switch (order.payment_method) {
      case 'stripe': {
        let stripe_session = (await get_json(`/api/stripe/get-order-checkout-session/${order_id}`)).data
        $page.on('click', '.paynow-btn', () => {
          window.location = stripe_session.url
        })
        $page.on('click', '.update-payment-status-btn', async (event) => {
          let btn = $page.find('.update-payment-status-btn')
          btn.prop('disabled', true)
            .css('opacity', '0.5')
          try {
            await post_json(`/api/stripe/update-order-payment-status/${order_id}`)
            order = (await get_json(`/api/order/by-id/${order_id}`)).data
            update_order(order)
          } catch (err) {
            alert_error(err)
          } finally {
            btn.prop('disabled', false)
              .css('opacity', '')
          }
        })
        break
      }
    }
    function update_order (order) {
      populate_order_with_lines(order)
      try { // replace title
        let idx = document.title.indexOf('|')
        let title_suffix = idx == -1 ? '' : ' ' + document.title.substring(idx)
        document.title = 'Order #' + order.order_num + title_suffix
      } catch (err) {
        console.warn(err)
      }
      order = Object.assign({}, order)
      order.myinfo = myinfo
      $order.html('')
      eval_html_template('#order-template', order, $order[0])
      $page.find('.paynow-btn').toggleClass('d-none', ['unpaid'].indexOf(order.status) == -1)
      let lines_completed = order.lines.filter((a) => ['credited'].indexOf(a.status) != -1).length == order.lines.length
      $page.find('.update-payment-status-btn').toggleClass('d-none', lines_completed && ['unpaid','unknown'].indexOf(order.status) == -1)
    }
  } catch (err) {
    $page.find('.loading-indicator').addClass('d-none')
    alert_error(err)
  }
}

function onPurchaseSuccess () {
  let $modal = alert_message_html('Order has completed', `
<p class="p-3">Enjoy using your package in ResellKit now, <a href="/u/package/list/">See my packages</a></p>
`)
  $modal.on('hide.bs.modal', () => {
    window.location = '/u/package/list/'
  })
}
